import { FC } from 'react';

import { TabButton, Wrapper } from './Wrapper';

type TabsProps = {
  tabs: string[];
  activeTab: number;
  onChangeTab(index: number): void;
};

const Tabs: FC<TabsProps> = ({ tabs, activeTab, onChangeTab }) => (
  <Wrapper>
    {tabs.map((t, index) => (
      <TabButton key={t} isActive={activeTab === index} onClick={() => onChangeTab(index)}>
        {t}
      </TabButton>
    ))}
  </Wrapper>
);

export default Tabs;
